import DeleteRelationShip from "../../../views/permissioncrud/DeleteRelationShip";
import ToolTip from "../../ToolTip/ToolTip";
export const RelationShipTableHeader = [
  {
    field: "sl_no",
    headerName: "Sl No",
  },
  // {
  //     field: "permission_relation_id",
  //     headerName: "permission_relation_id ",
  // },
  // {
  //     field: "permission_id",
  //     headerName: "permission_id",
  // },
  {
    field: "usertype",
    headerName: "User Type",
    width: 300,
  },
  {
    field: "permission_title",
    headerName: "Title",
    width: 180,
  },
  {
    field: "permission_path",
    headerName: "Path",
    width: 250,
  },
  // {
  //     field: "module_name",
  //     headerName: "Module Name",
  //     width:150
  // },
  {
    field: "department_name",
    headerName: "Depart Name",
    width: 200,
  },
  {
    field: "action",
    headerName: "Action",
    width: 200,
    renderCell: (param) => {
      return (
        <DeleteRelationShip
          relationId={param.row.permission_relation_id}
          permissionID={param.row.permission_id}
        />
      );
    },
  },
];
